export const getUserId = state => state.user.me.value;

export const getUser = state => state.entities.user[getUserId(state)];

export const getUserRole = state => getUser(state)?.role;

export const getUserCompanies = state =>
  state?.user?.userCompanies?.value ?? [];

// v2 /me returns pendingUserCompanies at the top level; v1 nests them under
// links.pendingUserCompanies. Support both shapes while the migration is gated
// behind the empMigrateMeToV2 feature flag.
export const getUserPendingUserCompanies = state =>
  getUser(state)?.pendingUserCompanies ??
  getUser(state)?.links?.pendingUserCompanies ??
  [];

// v2 /me flattens the status field; v1 keeps it under PendingUserCompany.status.
export const getPendingUserCompanyStatus = company =>
  company?.status ?? company?.PendingUserCompany?.status;

export const getUserPreferences = state => getUser(state)?.preferences ?? null;

export const getUserAppFeatures = state =>
  getUser(state)?.preferences?.features ?? null;

export const getUserNotifications = state =>
  getUser(state)?.preferences?.notifications ?? null;

export const getEmailVerificationStatus = state => getUser(state)?.isVerified;

export const getUserMetadata = state =>
  getUser(state)?.metadata?.employerMarketingParams ?? null;

export const getUserPhoneNumber = state => getUser(state)?.phone;

export const getIsPhoneNumberVerified = state =>
  getUser(state)?.isPhoneNumberVerified;
